export const feedApiKey = {
  createRecentlyViewedFeed: "create new recently viewed feed",
  deleteFeedRecentlyViewed: "delete recently viewed feed",
  createdLikedFeed: "create liked feed",
  deleteLikedFeed: "delete liked feed",
};
